import { ɵgetAllInstancesOf as _getAllInstancesOf, ɵgetDefaultInstanceOf as _getDefaultInstanceOf, VERSION, ɵAngularFireSchedulers as _AngularFireSchedulers, ɵzoneWrap as _zoneWrap } from '@angular/fire';
import { timer, from } from 'rxjs';
import { concatMap, distinct } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { InjectionToken, Optional, NgModule, makeEnvironmentProviders, NgZone, Injector } from '@angular/core';
import { FirebaseApp, FirebaseApps } from '@angular/fire/app';
import { AppCheckInstances } from '@angular/fire/app-check';
import { registerVersion } from 'firebase/app';
import { authState as authState$1, idToken as idToken$1, user as user$1 } from 'rxfire/auth';
import { applyActionCode as applyActionCode$1, beforeAuthStateChanged as beforeAuthStateChanged$1, checkActionCode as checkActionCode$1, confirmPasswordReset as confirmPasswordReset$1, connectAuthEmulator as connectAuthEmulator$1, createUserWithEmailAndPassword as createUserWithEmailAndPassword$1, deleteUser as deleteUser$1, fetchSignInMethodsForEmail as fetchSignInMethodsForEmail$1, getAdditionalUserInfo as getAdditionalUserInfo$1, getAuth as getAuth$1, getIdToken as getIdToken$1, getIdTokenResult as getIdTokenResult$1, getMultiFactorResolver as getMultiFactorResolver$1, getRedirectResult as getRedirectResult$1, initializeAuth as initializeAuth$1, initializeRecaptchaConfig as initializeRecaptchaConfig$1, isSignInWithEmailLink as isSignInWithEmailLink$1, linkWithCredential as linkWithCredential$1, linkWithPhoneNumber as linkWithPhoneNumber$1, linkWithPopup as linkWithPopup$1, linkWithRedirect as linkWithRedirect$1, onAuthStateChanged as onAuthStateChanged$1, onIdTokenChanged as onIdTokenChanged$1, parseActionCodeURL as parseActionCodeURL$1, reauthenticateWithCredential as reauthenticateWithCredential$1, reauthenticateWithPhoneNumber as reauthenticateWithPhoneNumber$1, reauthenticateWithPopup as reauthenticateWithPopup$1, reauthenticateWithRedirect as reauthenticateWithRedirect$1, reload as reload$1, revokeAccessToken as revokeAccessToken$1, sendEmailVerification as sendEmailVerification$1, sendPasswordResetEmail as sendPasswordResetEmail$1, sendSignInLinkToEmail as sendSignInLinkToEmail$1, setPersistence as setPersistence$1, signInAnonymously as signInAnonymously$1, signInWithCredential as signInWithCredential$1, signInWithCustomToken as signInWithCustomToken$1, signInWithEmailAndPassword as signInWithEmailAndPassword$1, signInWithEmailLink as signInWithEmailLink$1, signInWithPhoneNumber as signInWithPhoneNumber$1, signInWithPopup as signInWithPopup$1, signInWithRedirect as signInWithRedirect$1, signOut as signOut$1, unlink as unlink$1, updateCurrentUser as updateCurrentUser$1, updateEmail as updateEmail$1, updatePassword as updatePassword$1, updatePhoneNumber as updatePhoneNumber$1, updateProfile as updateProfile$1, useDeviceLanguage as useDeviceLanguage$1, validatePassword as validatePassword$1, verifyBeforeUpdateEmail as verifyBeforeUpdateEmail$1, verifyPasswordResetCode as verifyPasswordResetCode$1 } from 'firebase/auth';
export * from 'firebase/auth';
const AUTH_PROVIDER_NAME = 'auth';
class Auth {
  constructor(auth) {
    return auth;
  }
}
class AuthInstances {
  constructor() {
    return _getAllInstancesOf(AUTH_PROVIDER_NAME);
  }
}
const authInstance$ = /*#__PURE__*/ /*#__PURE__*/timer(0, 300).pipe(/*#__PURE__*/concatMap(() => from(_getAllInstancesOf(AUTH_PROVIDER_NAME))), /*#__PURE__*/distinct());
const PROVIDED_AUTH_INSTANCES = /*#__PURE__*/new InjectionToken('angularfire2.auth-instances');
function defaultAuthInstanceFactory(provided, defaultApp) {
  const defaultAuth = _getDefaultInstanceOf(AUTH_PROVIDER_NAME, provided, defaultApp);
  return defaultAuth && new Auth(defaultAuth);
}
function authInstanceFactory(fn) {
  return (zone, injector) => {
    const auth = zone.runOutsideAngular(() => fn(injector));
    return new Auth(auth);
  };
}
const AUTH_INSTANCES_PROVIDER = {
  provide: AuthInstances,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_AUTH_INSTANCES]]
};
const DEFAULT_AUTH_INSTANCE_PROVIDER = {
  provide: Auth,
  useFactory: defaultAuthInstanceFactory,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_AUTH_INSTANCES], FirebaseApp]
};
let AuthModule = /*#__PURE__*/(() => {
  class AuthModule {
    constructor() {
      registerVersion('angularfire', VERSION.full, 'auth');
    }
    static ɵfac = function AuthModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AuthModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AuthModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [DEFAULT_AUTH_INSTANCE_PROVIDER, AUTH_INSTANCES_PROVIDER]
    });
  }
  return AuthModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideAuth(fn, ...deps) {
  registerVersion('angularfire', VERSION.full, 'auth');
  return makeEnvironmentProviders([DEFAULT_AUTH_INSTANCE_PROVIDER, AUTH_INSTANCES_PROVIDER, {
    provide: PROVIDED_AUTH_INSTANCES,
    useFactory: authInstanceFactory(fn),
    multi: true,
    deps: [NgZone, Injector, _AngularFireSchedulers, FirebaseApps, [new Optional(), AppCheckInstances], ...deps]
  }]);
}

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const authState = /*#__PURE__*/_zoneWrap(authState$1, true);
const idToken = /*#__PURE__*/_zoneWrap(idToken$1, true);
const user = /*#__PURE__*/_zoneWrap(user$1, true);

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const applyActionCode = /*#__PURE__*/_zoneWrap(applyActionCode$1, true);
const beforeAuthStateChanged = /*#__PURE__*/_zoneWrap(beforeAuthStateChanged$1, true);
const checkActionCode = /*#__PURE__*/_zoneWrap(checkActionCode$1, true);
const confirmPasswordReset = /*#__PURE__*/_zoneWrap(confirmPasswordReset$1, true, 2);
const connectAuthEmulator = /*#__PURE__*/_zoneWrap(connectAuthEmulator$1, true);
const createUserWithEmailAndPassword = /*#__PURE__*/_zoneWrap(createUserWithEmailAndPassword$1, true, 2);
const deleteUser = /*#__PURE__*/_zoneWrap(deleteUser$1, true, 2);
const fetchSignInMethodsForEmail = /*#__PURE__*/_zoneWrap(fetchSignInMethodsForEmail$1, true, 2);
const getAdditionalUserInfo = /*#__PURE__*/_zoneWrap(getAdditionalUserInfo$1, true, 2);
const getAuth = /*#__PURE__*/_zoneWrap(getAuth$1, true);
const getIdToken = /*#__PURE__*/_zoneWrap(getIdToken$1, true);
const getIdTokenResult = /*#__PURE__*/_zoneWrap(getIdTokenResult$1, true);
const getMultiFactorResolver = /*#__PURE__*/_zoneWrap(getMultiFactorResolver$1, true);
const getRedirectResult = /*#__PURE__*/_zoneWrap(getRedirectResult$1, true);
const initializeAuth = /*#__PURE__*/_zoneWrap(initializeAuth$1, true);
const initializeRecaptchaConfig = /*#__PURE__*/_zoneWrap(initializeRecaptchaConfig$1, true);
const isSignInWithEmailLink = /*#__PURE__*/_zoneWrap(isSignInWithEmailLink$1, true);
const linkWithCredential = /*#__PURE__*/_zoneWrap(linkWithCredential$1, true, 2);
const linkWithPhoneNumber = /*#__PURE__*/_zoneWrap(linkWithPhoneNumber$1, true, 2);
const linkWithPopup = /*#__PURE__*/_zoneWrap(linkWithPopup$1, true, 2);
const linkWithRedirect = /*#__PURE__*/_zoneWrap(linkWithRedirect$1, true, 2);
const onAuthStateChanged = /*#__PURE__*/_zoneWrap(onAuthStateChanged$1, true);
const onIdTokenChanged = /*#__PURE__*/_zoneWrap(onIdTokenChanged$1, true);
const parseActionCodeURL = /*#__PURE__*/_zoneWrap(parseActionCodeURL$1, true);
const reauthenticateWithCredential = /*#__PURE__*/_zoneWrap(reauthenticateWithCredential$1, true, 2);
const reauthenticateWithPhoneNumber = /*#__PURE__*/_zoneWrap(reauthenticateWithPhoneNumber$1, true, 2);
const reauthenticateWithPopup = /*#__PURE__*/_zoneWrap(reauthenticateWithPopup$1, true, 2);
const reauthenticateWithRedirect = /*#__PURE__*/_zoneWrap(reauthenticateWithRedirect$1, true, 2);
const reload = /*#__PURE__*/_zoneWrap(reload$1, true, 2);
const revokeAccessToken = /*#__PURE__*/_zoneWrap(revokeAccessToken$1, true, 2);
const sendEmailVerification = /*#__PURE__*/_zoneWrap(sendEmailVerification$1, true, 2);
const sendPasswordResetEmail = /*#__PURE__*/_zoneWrap(sendPasswordResetEmail$1, true, 2);
const sendSignInLinkToEmail = /*#__PURE__*/_zoneWrap(sendSignInLinkToEmail$1, true, 2);
const setPersistence = /*#__PURE__*/_zoneWrap(setPersistence$1, true);
const signInAnonymously = /*#__PURE__*/_zoneWrap(signInAnonymously$1, true, 2);
const signInWithCredential = /*#__PURE__*/_zoneWrap(signInWithCredential$1, true, 2);
const signInWithCustomToken = /*#__PURE__*/_zoneWrap(signInWithCustomToken$1, true, 2);
const signInWithEmailAndPassword = /*#__PURE__*/_zoneWrap(signInWithEmailAndPassword$1, true, 2);
const signInWithEmailLink = /*#__PURE__*/_zoneWrap(signInWithEmailLink$1, true, 2);
const signInWithPhoneNumber = /*#__PURE__*/_zoneWrap(signInWithPhoneNumber$1, true, 2);
const signInWithPopup = /*#__PURE__*/_zoneWrap(signInWithPopup$1, true, 2);
const signInWithRedirect = /*#__PURE__*/_zoneWrap(signInWithRedirect$1, true, 2);
const signOut = /*#__PURE__*/_zoneWrap(signOut$1, true, 2);
const unlink = /*#__PURE__*/_zoneWrap(unlink$1, true, 2);
const updateCurrentUser = /*#__PURE__*/_zoneWrap(updateCurrentUser$1, true, 2);
const updateEmail = /*#__PURE__*/_zoneWrap(updateEmail$1, true, 2);
const updatePassword = /*#__PURE__*/_zoneWrap(updatePassword$1, true, 2);
const updatePhoneNumber = /*#__PURE__*/_zoneWrap(updatePhoneNumber$1, true, 2);
const updateProfile = /*#__PURE__*/_zoneWrap(updateProfile$1, true, 2);
const useDeviceLanguage = /*#__PURE__*/_zoneWrap(useDeviceLanguage$1, true, 2);
const validatePassword = /*#__PURE__*/_zoneWrap(validatePassword$1, true, 2);
const verifyBeforeUpdateEmail = /*#__PURE__*/_zoneWrap(verifyBeforeUpdateEmail$1, true, 2);
const verifyPasswordResetCode = /*#__PURE__*/_zoneWrap(verifyPasswordResetCode$1, true, 2);

/**
 * Generated bundle index. Do not edit.
 */

export { Auth, AuthInstances, AuthModule, applyActionCode, authInstance$, authState, beforeAuthStateChanged, checkActionCode, confirmPasswordReset, connectAuthEmulator, createUserWithEmailAndPassword, deleteUser, fetchSignInMethodsForEmail, getAdditionalUserInfo, getAuth, getIdToken, getIdTokenResult, getMultiFactorResolver, getRedirectResult, idToken, initializeAuth, initializeRecaptchaConfig, isSignInWithEmailLink, linkWithCredential, linkWithPhoneNumber, linkWithPopup, linkWithRedirect, onAuthStateChanged, onIdTokenChanged, parseActionCodeURL, provideAuth, reauthenticateWithCredential, reauthenticateWithPhoneNumber, reauthenticateWithPopup, reauthenticateWithRedirect, reload, revokeAccessToken, sendEmailVerification, sendPasswordResetEmail, sendSignInLinkToEmail, setPersistence, signInAnonymously, signInWithCredential, signInWithCustomToken, signInWithEmailAndPassword, signInWithEmailLink, signInWithPhoneNumber, signInWithPopup, signInWithRedirect, signOut, unlink, updateCurrentUser, updateEmail, updatePassword, updatePhoneNumber, updateProfile, useDeviceLanguage, user, validatePassword, verifyBeforeUpdateEmail, verifyPasswordResetCode };
